import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Collapse } from 'antd';

const HistogramChart = (props) => {
    const { Panel } = Collapse;

    let histogramBars = props.getAnalysisRes.histogram.chart.histogram_bars;
    let histogramBinLabels =
        props.getAnalysisRes.histogram.chart.histogram_bin_labels;
    let histogramFittedLineX =
        props.getAnalysisRes.histogram.chart.fitted_line_x;
    let histogramFittedLineY =
        props.getAnalysisRes.histogram.chart.fitted_line_y;

    let histogramFittedLineXLognormal =
        props.getAnalysisRes.histogram.chart.fitted_line_x_lognormal;
    let histogramFittedLineYLognormal =
        props.getAnalysisRes.histogram.chart.fitted_line_y_lognormal;

    let histogramFittedLineXBurr12 =
        props.getAnalysisRes.histogram.chart.fitted_line_x_burr12;
    let histogramFittedLineYBurr12 =
        props.getAnalysisRes.histogram.chart.fitted_line_y_burr12;


    // let histDisplayName = Object.values(
    //     props.getAnalysisRes.histogram.statistics.count
    // )[0];

    let dotplotDisplayName = props.getAnalysisRes.display_name;

    function format_bins(bins) {
        let return_array = [];

        for (var i = 0; i < bins.length; i++) {
            let tmp = bins[i][0].toString() + '-' + bins[i][1].toString();
            return_array.push(tmp);
        }

        return return_array;
    }

    let histogramOptions = {
        credits: {
            enabled: false
        },

        chart: {
            renderTo: 'chart-container-1'
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },

        title: { text: '', style: { fontSize: '11px' } },
        subtitle: { text: '', style: { fontSize: '10px' } },
        xAxis: [
            {
                categories: format_bins(histogramBinLabels),
                labels: { style: { fontSize: '9px' } }
                //min: 0,
                //max: 5
            },

            {
                categories: histogramFittedLineX,
                tickLength: 0,
                lineWidth: 0,
                labels: { enabled: false },
                title: {
                    text: 'Bins of ' + dotplotDisplayName,
                    style: {
                        fontWeight: 'normal',
                        fontSize: '10px'
                    },
                    margin: -10
                }
            },
            {
                categories: histogramFittedLineXLognormal,
                tickLength: 0,
                lineWidth: 0,
                labels: { enabled: false },
                // title: {
                //     text: 'Bins of ' + dotplotDisplayName,
                //     style: {
                //         fontWeight: 'normal',
                //         fontSize: '10px'
                //     },
                //     margin: -10
                // }
            },
            {
                categories: histogramFittedLineXBurr12,
                tickLength: 0,
                lineWidth: 0,
                labels: { enabled: false },
            }
        ],
        yAxis: [
            {
                // Primary yAxis
                //minorTickInterval: 'auto',
                labels: {
                    formatter: function () {
                        return this.value;
                    },
                    style: {
                        fontSize: '9px',
                        color: '#6D869F'
                    }
                },
                title: {
                    text: 'Count',
                    style: {
                        fontWeight: 'normal',
                        fontSize: '10px'
                    }
                }
            }
        ],
        plotOptions: {
            series: { animation: true },
            spline: { animation: true }
        },

        tooltip: {
            formatter: function () {
                var unit = {}[this.series.name];

                if (this.color == '#0586C6')
                    return 'Count: ' + this.y.toFixed(3);
                //Math.round(this.y)
                else
                    return (
                        ' X: ' +
                        Number(this.x).toFixed(4) +
                        ' Y:' +
                        Number(this.y).toFixed(4)
                    );
            }
        },
        legend: {
            enabled: true,
            layout: 'vertical',
            align: 'right',
            x: 15,
            verticalAlign: 'top',
            y: 0,
            floating: true,
            backgroundColor: '#FFFFFF'
        },

        series: [
            {
                name: 'Bins',
                // color: '#74B8D9',
                color: '#407cb1',
                type: 'column',
                yAxis: 0,
                data: histogramBars,
                showInLegend:false
            },

            {
                name: 'Normal Fit',
                type: 'spline',
                color: '#60091d',
                xAxis: 1,
                yAxis: 0,
                data: histogramFittedLineY,
                marker: { enabled: false }
            },
            {
                name: 'Lognormal Fit',
                type: 'spline',
                color: '#76ac54',
                xAxis: 1,
                yAxis: 0,
                data: histogramFittedLineYLognormal,
                marker: { enabled: false }
            },
            {
                name: 'Burr12 Fit',
                type: 'spline',
                color: '#cb2e26',
                xAxis: 1,
                yAxis: 0,
                data: histogramFittedLineYBurr12,
                marker: { enabled: false }
            }
        ]
    };

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Histogram ${props.getAnalysisRes.filter_by_variable == null ? '': `[${props.getAnalysisRes.filter_by_variable}]`}`}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={histogramOptions}
                        ref={props.forwardedRef}
                    />
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(HistogramChart);
